<template>
  <div ref="entra_form">
    <b-overlay
      ref="overlay_index"
      :show="showLoading"
      spinner-variant="primary"
      blur="0"
      opacity=".75"
      rounded="sm"
    >
      <b-card>
        <b-row>
          <b-col
            sm="1"
            class="d-flex justify-content-center align-items-center mt-1"
          >
            <b-button variant="danger" @click="$router.go(-1)">Atrás</b-button>
          </b-col>

          <!-- Correlativo -->
          <b-col sm="4" md="4" lg="2" xl="2">
            <b-form-group label="Correlativo">
              <b-form-input
                id="correlativo"
                placeholder="Correlativo"
                v-model="form.correlativo"
                trim
              />
            </b-form-group>
          </b-col>

          <!-- Establecimiento de Origen -->
          <b-col sm="4" md="4" lg="3" xl="3">
            <b-form-group label="Establecimiento Origen">
              <v-select
                :options="stores"
                label="name"
                v-model="form.storeOrigin"
                :reduce="(store) => store.id"
                placeholder="Seleccionar establecimiento"
                @input="loadAutoparts"
              />
            </b-form-group>
          </b-col>

          <!-- Fecha Límite -->
          <b-col sm="4" md="4" lg="2">
            <b-form-group label="Fecha Límite">
              <b-form-input type="date" v-model="form.fechaLimite" />
            </b-form-group>
          </b-col>

          <!-- Cliente -->
          <b-col sm="2" md="2" lg="2">
            <b-form-group label="Cliente">
              <v-select
                :options="clients"
                label="label"
                v-model="form.selectedClient"
                :reduce="(client) => client"
                placeholder="Seleccionar cliente"
              />
            </b-form-group>
          </b-col>
          <b-col
            sm="2"
            class="d-flex justify-content-center align-items-center mt-1"
          >
            <b-button
              :disabled="tableItems.length === 0"
              variant="primary"
              @click="saveLoan"
            >
              Guardar
            </b-button>
          </b-col>
        </b-row>
      </b-card>

      <!-- Card para agregar autopartes -->
      <b-card class="mt-4">
        <b-row>
          <b-col md="12">
            <b-form-group label="Autoparte">
              <v-select
                :options="autoparts"
                label="label"
                v-model="newItem.autopart"
                :reduce="(autopart) => autopart"
                placeholder="Seleccionar autoparte"
                :filterable="true"
                :filter-by="customFilter"
                @input="updateQtyAvailable"
              />
            </b-form-group>
          </b-col>

          <b-col sm="4" md="2" lg="2">
            <b-form-group label="Cantidad Disponible">
              <b-form-input
                type="number"
                v-model="newItem.qtyAvailable"
                readonly
              />
            </b-form-group>
          </b-col>

          <b-col sm="4" md="2" lg="2">
            <b-form-group label="Cantidad Solicitada">
              <b-form-input
                v-model="newItem.requiredQty"
                type="number"
                placeholder="Ingrese cantidad"
                @keypress="validateRequiredQty"
              />
            </b-form-group>
          </b-col>

          <b-col md="2">
            <b-form-group label="Tipos de precio">
              <v-select
                :options="priceOptions"
                label="name"
                v-model="newItem.selectedPrice"
                :reduce="(price) => price.value"
                placeholder="Seleccionar precio"
                @input="updatePrice"
              />
            </b-form-group>
          </b-col>

          <b-form-group label="Precio seleccionado" class="ml-1">
            <b-form-input
              v-model.number="newItem.unitPrice"
              :class="{ 'is-invalid': newItem.unitPrice < newItem.minPrice }"
              type="number"
              placeholder="Ingrese precio"
              @keydown="preventInvalidPrice"
              @blur="enforceMinPrice"
            />
            <b-form-invalid-feedback
              v-if="newItem.unitPrice < newItem.minPrice"
            >
              El precio no puede ser menor al mínimo permitido ({{
                newItem.minPrice
              }}).
            </b-form-invalid-feedback>
          </b-form-group>

          <b-col sm="4" md="2" class="d-flex align-items-center mt-1 ml-1">
            <b-button variant="primary" @click="addRow">Agregar</b-button>
          </b-col>
        </b-row>

        <!-- Tabla -->
        <b-card v-if="tableItems.length > 0" no-body>
          <b-table
            :items="tableItems"
            :fields="fields"
            responsive
            hover
            class="border border-2 rounded mt-2"
          >
            <template #cell(actions)="data">
              <b-button
                size="sm"
                variant="danger"
                @click="removeRow(data.index)"
              >
                Eliminar
              </b-button>
            </template>
          </b-table>
        </b-card>
      </b-card>

      <b-card class="mt-1">
        <h4 class="font-weight-bold">Resumen de Costos</h4>
        <b-table
          small
          :items="calculatedItems"
          :fields="summary"
          responsive
          hover
          class="border border-2 rounded mt-2"
          head-variant="light"
          style="font-size: 1.1rem"
        >
          <template #cell(unitPrice)="data">
            {{ currencySymbol }} {{ data.item.unitPrice }}
          </template>
          <template #cell(cost)="data">
            {{ currencySymbol }} {{ data.item.cost }}
          </template>
        </b-table>
        <b-row class="mt-3">
          <b-col class="text-right font-weight-bold" style="font-size: 1.25rem">
            Total:
          </b-col>
          <b-col
            class="text-left text-primary font-weight-bold"
            style="font-size: 1.5rem"
          >
            {{ currencySymbol }} {{ totalCost.toFixed(2) }}
          </b-col>
        </b-row>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from "vue";
import { BootstrapVue, BootstrapVueIcons, VBTooltip } from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import StoreService from "@/services/StoresService";
import InventoryService from "@/services/InventoryService";
import UserService from "@/services/UserService";
import LoanService from "@/services/LoanService";
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
export default {
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  data() {
    return {
      showLoading: false,
      form: {
        correlativo: "",
        storeOrigin: null,
        fechaLimite: "",
        selectedClient: null,
      },
      newItem: {
        autopart: null,
        qtyAvailable: 0,
        requiredQty: null,
        unitPrice: 0,
        selectedPrice: null,
        minPrice: 0,
      },
      priceOptions: [
        { name: "Precio Tienda", value: "retailPrice" },
        { name: "Precio x Mayor", value: "wholesalePrice" },
        { name: "Precio Cliente Final", value: "clientPrice" },
      ],
      stores: [],
      clients: [],
      categories: [],
      autoparts: [],
      tableItems: [],
      userEstablishments: [],
      fields: [
        { key: "autopart.uniqueCode", label: "Código Único" },
        { key: "autopart.label", label: "Autoparte" },
        { key: "qtyAvailable", label: "Cantidad Disponible" },
        { key: "requiredQty", label: "Cantidad Solicitada" },
        { key: "unitPrice", label: "Precio Unitario" },
        { key: "actions", label: "Acciones" },
      ],
      summary: [
        { key: "uniqueCode", label: "Código Único" },
        { key: "description", label: "Descripción" },
        { key: "quantity", label: "Cantidad" },
        { key: "unitPrice", label: "Precio Unitario" },
        { key: "cost", label: "Costo (Cantidad x Precio)" },
      ],
    };
  },
  components: {
    vSelect,
  },
  computed: {
    currencySymbol() {
      return this.form.currencyType === "Dólar" ? "$" : "S/";
    },

    calculatedItems() {
      return this.tableItems.map((item) => ({
        uniqueCode: item.autopart.uniqueCode,
        description: item.autopart.label,
        quantity: item.requiredQty,
        unitPrice: item.unitPrice.toFixed(2),
        cost: (item.requiredQty * item.unitPrice).toFixed(2),
      }));
    },

    totalCost() {
      return this.tableItems.reduce((sum, item) => {
        return sum + item.requiredQty * item.unitPrice;
      }, 0);
    },
  },
  watch: {
    "newItem.unitPrice"(value) {
      if (value < this.newItem.minPrice) {
        this.newItem.unitPrice = this.newItem.minPrice;
      }
    },

    "form.storeOrigin": function (newValue) {
      this.newItem.autopart = null;
      this.newItem.qtyAvailable = null;
      this.newItem.requiredQty = null;
      this.newItem.selectedPrice = null;
      this.newItem.unitPrice = 0;

      this.tableItems = [];

      if (newValue) {
        this.loadAutoparts(newValue);
      } else {
        this.categories = [];
      }
    },

    "newItem.autopart": function (newValue) {
      this.newItem.qtyAvailable = null;
      this.newItem.requiredQty = null;
      this.newItem.selectedPrice = null;
      this.newItem.unitPrice = 0;

      if (newValue) {
        this.updateQtyAvailable();
      }
    },

    "newItem.selectedPrice": function (newValue) {
      if (!newValue || !this.newItem.autopart) {
        this.newItem.unitPrice = 0;
        return;
      }
      const selectedPrice = parseFloat(this.newItem.autopart[newValue]);
      this.newItem.unitPrice = selectedPrice || 0;
      this.newItem.minPrice = selectedPrice || 0;
    },
  },
  mounted() {
    this.loadStores();
    this.datosUser = JSON.parse(localStorage.getItem("userData"));
    this.userEstablishments = this.datosUser?.data?.userEstablishments || [];
    this.userEstablishments = this.userEstablishments.map(
      (establishment) => establishment.id
    );
    console.log("my stablishments", this.userEstablishments);
    this.loadClients();
  },
  methods: {
    updateQtyAvailable() {
      if (!this.newItem.autopart) {
        this.newItem.qtyAvailable = null;
        return;
      }
      this.newItem.qtyAvailable = this.newItem.autopart.qtyAvailable;
    },

    preventInvalidPrice(event) {
      const newValue = parseFloat(event.target.value + event.key);
      if (newValue < this.newItem.minPrice && !isNaN(newValue)) {
        event.preventDefault();
      }
    },

    enforceMinPrice() {
      if (this.newItem.unitPrice < this.newItem.minPrice) {
        this.newItem.unitPrice = this.newItem.minPrice;
      }
    },

    validateRequiredQty(event) {
      const maxQty = parseInt(this.newItem.qtyAvailable) || 0;
      const currentValue = this.newItem.requiredQty?.toString() || "";
      const char = String.fromCharCode(event.keyCode || event.which);

      const newValue = parseInt(currentValue + char) || 0;

      if (newValue > maxQty || isNaN(newValue)) {
        event.preventDefault();
      }
    },

    async loadStores() {
      const userData = JSON.parse(localStorage.getItem("userData"));
      const userEstablishments = userData?.data?.userEstablishments || [];

      this.stores = userEstablishments.map((est) => ({
        id: est.id,
        name: est.name,
      }));
    },
    updatePrice() {
      if (!this.newItem.autopart || !this.newItem.selectedPrice) {
        this.newItem.unitPrice = 0;
        this.newItem.minPrice = 0;
        return;
      }

      const selectedPrice = parseFloat(
        this.newItem.autopart[this.newItem.selectedPrice]
      );
      this.newItem.unitPrice = selectedPrice;
      this.newItem.minPrice = selectedPrice;
    },

    async loadClients() {
      const response = await UserService.getUsers("", this.$store);
      console.log("CLIENTES:", response);
      this.clients = response.data.rows
        .filter((user) => user.role.name === "Cliente")
        .map((client) => ({
          id: client.id,
          fullname: client.fullname,
          document: client.document,
          label: `${client.document} - ${client.fullname}`,
        }));
    },

    customFilter(option, label, search) {
      if (!search) return true;
      const normalizedLabel = label.toLowerCase();
      const normalizedSearch = search.toLowerCase().split(" ");
      return normalizedSearch.every((word) => normalizedLabel.includes(word));
    },

    async loadAutoparts() {
      if (!this.form.storeOrigin) return;
      const response = await InventoryService.getStockxStore(
        this.form.storeOrigin,
        this.$store
      );
      this.autoparts = response.data.map((item) => ({
        id: item.autopart.id,
        uniqueCode: item.autopart.uniqueCode,
        label: `${item.autopart.AutopartBrand.name} - ${item.autopart.originalCode} - ${item.autopart.description}`,
        AutopartBrand: { name: item.autopart.AutopartBrand.name },
        qtyAvailable: item.qtyAvailable,
        retailPrice: item.autopart.retailPrice,
        wholesalePrice: item.autopart.wholesalePrice,
        clientPrice: item.autopart.clientPrice,
      }));
    },

    addRow() {
      if (
        !this.newItem.autopart ||
        !this.newItem.requiredQty ||
        !this.newItem.selectedPrice ||
        this.newItem.unitPrice === 0
      ) {
        this.$swal(
          "Error",
          "Complete todos los campos antes de agregar una autoparte.",
          "error"
        );
        return;
      }

      if (this.newItem.unitPrice < this.newItem.minPrice) {
        console.log(
          "Precio inválido detectado:",
          this.newItem.unitPrice,
          this.newItem.minPrice
        );
        this.$swal(
          "Error",
          `El precio ingresado (${this.newItem.unitPrice}) no puede ser menor al mínimo permitido (${this.newItem.minPrice}).`,
          "error"
        );
        return;
      }

      if (
        this.tableItems.find(
          (item) => item.autopart.id === this.newItem.autopart.id
        )
      ) {
        this.$swal("Error", "La autoparte ya está en la lista.", "error");
        return;
      }

      this.tableItems.push({
        autopart: {
          id: this.newItem.autopart.id,
          uniqueCode: this.newItem.autopart.uniqueCode,
          label: this.newItem.autopart.label,
          AutopartBrand: {
            name: this.newItem.autopart.AutopartBrand.name,
          },
        },
        qtyAvailable: this.newItem.qtyAvailable,
        requiredQty: this.newItem.requiredQty,
        unitPrice: this.newItem.unitPrice,
      });

      this.newItem = {
        autopart: null,
        qtyAvailable: 0,
        requiredQty: null,
        unitPrice: 0,
        selectedPrice: null,
        minPrice: 0,
      };
    },
    removeRow(index) {
      this.tableItems.splice(index, 1);
    },
    async saveLoan() {
      if (
        !this.form.correlativo ||
        !this.form.storeOrigin ||
        !this.form.fechaLimite ||
        !this.form.selectedClient
      ) {
        this.$swal("Error", "Complete todos los campos del préstamo.", "error");
        return;
      }

      if (this.tableItems.length === 0) {
        this.$swal(
          "Error",
          "Debe agregar al menos una autoparte al préstamo.",
          "error"
        );
        return;
      }

      const payload = {
        documentCode: this.form.correlativo,
        establishmentOriginId: this.form.storeOrigin,
        clientId: this.form.selectedClient?.id,
        limitDate: new Date(this.form.fechaLimite),
        autoparts: this.tableItems.map((item) => ({
          autopartId: item.autopart.id,
          qty: parseInt(item.requiredQty),
          unitPrice: parseFloat(item.unitPrice),
        })),
      };

      try {
        this.showLoading = true;
        console.log("Payload a enviar:", payload);

        const response = await LoanService.saveLoan(payload, this.$store);
        console.log("Respuesta del backend:", response);

        this.$swal(
          "Éxito",
          "El préstamo ha sido guardado correctamente.",
          "success"
        );

        this.form = {
          correlativo: "",
          storeOrigin: null,
          fechaLimite: "",
          clientId: null,
        };
        this.tableItems = [];
        this.$router.push("/prestamo");
      } catch (error) {
        console.error("Error al guardar el préstamo:", error);
        this.$swal(
          "Error",
          "Ocurrió un problema al guardar el préstamo.",
          "error"
        );
      } finally {
        this.showLoading = false;
      }
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
